import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { TelephoneIcon } from '@repo/ui/icons'

import ClientSpacePageTitle from '../../../components/pages/client-space/client-space-page-title'
import HostFamilyCard from '../../../components/pages/client-space/trip-information/client-enrollment-host-family-card'
import ClientOtoIndividualOnSiteContacts from '../../../components/pages/client-space/trip-information/client-oto-individual-on-site-contacts'
import useEnrollment from '../../../lib/hooks/use-enrollment'

// the contacts a parent needs during a One to One Individuel stay: no center, no trip, so the
// journey contact page does not apply and this one takes its place in the client space
const ClientOtoIndividualContactPage = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientSpacePageTitle
        icon={<TelephoneIcon color={tailwindColors.primary.dark.DEFAULT} />}
        title="Coordonnées pendant le séjour"
      />
      {/* the host family only reaches the parents once LEC has diffused it: the endpoint answers
          with nothing until then, and the card says so */}
      <HostFamilyCard enrollmentId={enrollment.id} />
      <ClientOtoIndividualOnSiteContacts
        enrollmentId={enrollment.id}
        transferMethod={enrollment.otoIndividualProposition?.transferMethod}
      />
    </div>
  )
}

export default ClientOtoIndividualContactPage
